// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__4Ax7p","label":"Section_label__2ATsV","contentWrap":"Section_contentWrap__1AR6K","footer":"Section_footer__3Op1L","footerInner":"Section_footerInner__1frB5"};